module.exports = __webpack_public_path__ + "media/images/CO2-a3da50fe4691ca541502064dac6d4e99.svg";